var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleInterrogateIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.805,
    height: 20.805,
    viewBox: "0 0 20.805 20.805",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dudas",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_37890",
    "data-name": "Grupo 37890"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_51370",
    "data-name": "Trazado 51370",
    d: "M16.271,10.4c.939,0,1.5.5,1.5,1.346,0,1.535-2.74,1.958-2.74,3.821a1,1,0,0,0,1,1.049c1.033,0,.908-.767,1.284-1.316.5-.735,2.834-1.518,2.834-3.554,0-2.207-1.972-3.132-3.977-3.132-1.909,0-3.664,1.362-3.664,2.9a.937.937,0,0,0,1.018.955C15.05,12.465,14.268,10.4,16.271,10.4Z",
    transform: "translate(-6.181 -4.254)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_51371",
    "data-name": "Trazado 51371",
    d: "M19.629,27.72A1.284,1.284,0,1,0,18.345,29,1.29,1.29,0,0,0,19.629,27.72Z",
    transform: "translate(-8.427 -13.058)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_51372",
    "data-name": "Trazado 51372",
    d: "M20.305,10.153A10.153,10.153,0,1,0,10.153,20.305,10.164,10.164,0,0,0,20.305,10.153Zm-19.293,0a9.14,9.14,0,1,1,9.14,9.14A9.151,9.151,0,0,1,1.012,10.153Z",
    stroke: "#000",
    strokeWidth: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleInterrogateIcon);
export default __webpack_public_path__ + "static/media/circle_interrogate_icon.5f0a7400.svg";
export { ForwardRef as ReactComponent };